import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from './index';

const initialState: any = {
    settings: null,
};

const onboardReviewEditable = createSlice({
    name: 'onboardReviewEditable',
    initialState,
    reducers: {
        setOnboardReviewEditable(state, action: PayloadAction<any>) {
            state.settings = action.payload;
        },
    },
});

export const getOnboardReviewEditableSettings = (data: boolean) => {
    return async (dispatch: AppDispatch) => {
        try {
            dispatch(onboardReviewEditable.actions.setOnboardReviewEditable(data));
        } catch (err) {
            console.log('error from onboardReviewEditableSlice', err);
        }
    };
};

export default onboardReviewEditable.reducer;
export const { setOnboardReviewEditable } = onboardReviewEditable.actions;
